import httpClient from './httpClient'

export default {
  async getWebhooks() {
    let ret = await httpClient.get('/user/webhook/')
    return ret
  },
  async createWebhook(data) {
    let ret = await httpClient.post('/user/webhook', data)
    return ret
  },
  async deleteWebhook(id) {
    let ret = await httpClient.delete(`/user/webhook/${id}`)
    return ret
  },
}
